import { render, staticRenderFns } from "./DownloadShared.vue?vue&type=template&id=6701c460&"
import script from "./DownloadShared.vue?vue&type=script&lang=js&"
export * from "./DownloadShared.vue?vue&type=script&lang=js&"
import style0 from "./DownloadShared.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports